import * as React from 'react';

import { observer } from 'mobx-react';

import classnames from 'classnames';

interface ICenterMessageViewProps {
    className?: string;
    children: React.ReactNode;
}

export const CenterMessageView = observer((props: ICenterMessageViewProps) => {
    const { className, children } = props;
    const containerClassName = classnames(className, 'elc-iam-center-message-view-container');

    return <div className={containerClassName}>{children}</div>;
});
